
const SaleIcon = () => {
	return (
		<svg
			fill="none"
			height="1em"
			viewBox="0 0 25 26"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.937 10.761l-.537-.523a.75.75 0 00.536 1.273v-.75zM12.5 3l.537-.523a.75.75 0 00-1.074 0L12.5 3zm7.563 7.761v.75a.749.749 0 00.537-1.273l-.537.523zm2.834 13.489H2.103v1.5h20.794v-1.5zm-20.794 0a.368.368 0 01-.353-.382H.25c0 1.02.812 1.882 1.853 1.882v-1.5zm-.353-.382V12.01H.25v11.858h1.5zm0-11.858c0-.23.176-.383.353-.383v-1.5c-1.041 0-1.853.861-1.853 1.883h1.5zm.353-.383h20.794v-1.5H2.103v1.5zm20.794 0c.177 0 .353.153.353.383h1.5c0-1.021-.812-1.883-1.853-1.883v1.5zm.353.383v11.858h1.5V12.01h-1.5zm0 11.858c0 .23-.176.382-.353.382v1.5c1.041 0 1.853-.861 1.853-1.882h-1.5zM5.474 11.285l7.563-7.762-1.074-1.046-7.563 7.76 1.074 1.048zm6.489-7.762l7.563 7.762 1.074-1.047-7.563-7.761-1.074 1.046zm8.1 6.488H4.937v1.5h15.126v-1.5z"
				fill="currentColor"
			/>
			<path
				clipRule="evenodd"
				d="M14 2.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0114 2.5z"
				fill="none"
				fillRule="evenodd"
			/>
			<path
				clipRule="evenodd"
				d="M14 2.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0114 2.5z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default SaleIcon;
